import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import { YELLOW } from '../../../constants/colors';

export default {
  instructions: css`
    margin-bottom:30px;
    font-size: ${rem(14)};
  `,
  invoiceTerms: css`
    margin-top:15px;
    font-size: ${rem(14)};
  `,
  wrapper: css`
    background-color: #FAFAFA;
    padding: 30px 18px;
    margin-left: -8px;
    margin-right: -8px;
    margin-bottom: 32px;
  `,
  titleWrapper: css`
    padding: 12px 18px;
    margin-top: 0;
    background-color: #EDF2F7;
    margin-left: -8px;
    margin-right: -8px;
    border-bottom: 1px solid #D8DEE6;

    ${media.sm`
      margin-top: 32px;
    `}
  `,
  continueButton: css`
    margin-right: 0;
    margin-top: 16px;
  `,
  continueWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  `,
  errorWrapper: ({ hasError }) => css`
    display: flex;
    justify-content: center;
    overflow: hidden;
    color: black;
    background-color: ${YELLOW};
    max-height: 0;
    height: auto;
    will-change: max-height;
    transition: max-height 0.3s ease-in-out, height 0.3s ease-in-out;
    p {
      margin: 0;
      padding: 8px 26px;
      ${media.sm`
        padding: 8px;
      `}
    }
    ${hasError && css`
      height: auto;
      max-height: 200px;
    `}
  `,
  successMessage: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    flex: 1;
  `
};
